/**
 * Regex to determine if a string is only punctuation.
 *
 * Punctuation values taken into account by the TTS service:
 * @see https://www.figma.com/file/Fov7PSHFdXk6gvu5WyONix/V11-Cues?type=design&node-id=699%3A44341&t=oXwBXiWZeKcc7RES-1
 */
const PAUSE_TOKEN_REGEX = /^[.,!?;:]\s$/;

/**
 * Uses a regex to determine if a string is only punctuation.
 */
// todo: rename this
export const isPauseToken = (str: string): boolean => {
  return new RegExp(PAUSE_TOKEN_REGEX).test(str);
};

export default isPauseToken;
